import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { asPlanLimit, getApiError } from '../services/api';

const STATUS_KEY: Record<number, string> = {
    400: 'invalid',
    401: 'forbidden',
    403: 'forbidden',
    404: 'notFound',
    409: 'conflict',
    422: 'invalid',
};

/** Returns a function turning any thrown value into a translated, user-facing message. */
export const useApiError = (): ((e: unknown) => string) => {
    const { t } = useTranslation();
    return useCallback(
        (e: unknown) => {
            const limit = asPlanLimit(e);
            if (limit) return t(`errors.planLimit.${limit.limit}`, { count: limit.max, plan: t(`plans.${limit.plan}`) });
            const err = getApiError(e);
            if (err.status === null) return t('errors.network');
            if (err.code === 'MONTH_CLOSED') return t('errors.monthClosed');
            // The API's own wording is English only: translate by status, never show err.message.
            const key = STATUS_KEY[err.status ?? 0];
            return key ? t(`errors.${key}`) : t('errors.generic');
        },
        [t]
    );
};
